import {Component, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NbButtonGroupModule, NbButtonModule, NbCardModule, NbSelectModule, NbSpinnerModule} from '@nebular/theme';
import {StandingsService} from '../../services/standings.service';
import {Standings} from '../../models/standings';
import {TeamsService} from '../../services/teams.service';
import {forkJoin, of, switchMap} from 'rxjs';
import {DivisionSelectorComponent} from '../../shared/components/division-selector/division-selector.component';
import {Division} from '../../models/division';
import {StandingsTableComponent} from "../../shared/components/standings-table/standings-table.component";
import {Title} from "@angular/platform-browser";
import {StorageService} from "../../services/storage.service";
import {Utils} from "../../shared/utils";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-standings',
  standalone: true,
  imports: [
    TranslateModule,FormsModule, NbSelectModule, NbButtonModule, NbButtonGroupModule, NbCardModule, DivisionSelectorComponent, StandingsTableComponent, NbSpinnerModule],
  templateUrl: './standings.component.html',
  styleUrl: './standings.component.scss'
})
export class StandingsComponent {
  loading = false;
  selectedDivisionId = signal<string>('');
  divisions = signal<Division[]>([]);
  groups = signal<Division[]>([]);
  standingsGroupA = signal<Standings[]>([]);
  standingsGroupB = signal<Standings[]>([]);
  standingsGroupC = signal<Standings[]>([]);
  standingsGroupD = signal<Standings[]>([]);
  currentTitle!: string;

  constructor(
    private readonly title: Title, private standingsService: StandingsService,
    private teamsService: TeamsService, private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.currentTitle = this.title.getTitle();

    const observable = this.teamsService.divisions().pipe(
      switchMap(divisions => {
        const firstDivision = divisions[0];
        return forkJoin({
          divisions: of(divisions),
          groups: this.teamsService.groupsByDivision(firstDivision.division_id)
        });
      })
    );

    observable.subscribe((result) => {
      Utils.setFirstDivisionForSignal(this.selectedDivisionId, result.divisions);
      this.divisions.set(result.divisions);
      this.groups.set(result.groups);
      const saved = this.storageService.getSelectedDivisionId();
      if (saved) {
        this.selectedDivisionId.set(saved);
      }
      this.search();
    });
  }

  onDivisionChange($event: any) {
    this.selectedDivisionId.set($event);
    this.storageService.storeSelectedDivisionId(this.selectedDivisionId());
    this.teamsService.groupsByDivision(this.selectedDivisionId()).subscribe((result) => {
      this.groups.set(result);
      this.search();
    });
  }

  search() {
    this.loading = true;
    this.standingsService.teamsByDivision(this.selectedDivisionId()).subscribe((response: any) => {
      const standingsGroupA: Standings[] = [];
      const standingsGroupB: Standings[] = [];
      const standingsGroupC: Standings[] = [];
      const standingsGroupD: Standings[] = [];

      response.forEach((data: any) => {
        if (data.group_id == 'A') {
          standingsGroupA.push(data);
        }
        else if (data.group_id == 'B') {
          standingsGroupB.push(data);
        }
        else if (data.group_id == 'C') {
          standingsGroupC.push(data);
        }
        else if (data.group_id == 'D') {
          standingsGroupD.push(data);
        }
      });
      this.standingsGroupA.set(standingsGroupA);
      this.standingsGroupB.set(standingsGroupB);
      this.standingsGroupC.set(standingsGroupC);
      this.standingsGroupD.set(standingsGroupD);

      this.loading = false;
    });
  }
}
